export const ORDERS_LIST = "PLATFORMS_PORTAL_ORDERS_LIST";
export const ORDERS_SHOW = "PLATFORMS_PORTAL_ORDERS_SHOW";
export const ORDERS_CREATE = "PLATFORMS_PORTAL_ORDERS_CREATE";
export const ORDERS_TASKS_TIMELINES_SHOW = "PLATFORMS_PORTAL_ORDERS_TASKS_TIMELINES_SHOW";
